<template>
  <div class="equipament-photos-main">
    <Toast :style="{ width: $isMobile() ? '100vw' : '' }" />
    <Dialog
      id="'dialog-equipament-photos'"
      :visible.sync="show"
      :style="{ width: $isMobile() ? '100vw' : '40vw', position: 'relative' }"
      v-bind:class="[{ 'p-dialog-maximized': $isMobile() }]"
      :modal="true"
      :closable="false"
      :header="'Fotografias do Equipamento'"
    >
      <Loading
        :active.sync="loading"
        :isFullPage="false"
        :zIndex="9000"
      ></Loading>
      <form
        name="equipamentPhotosForm"
        class="p-col-12"
        @submit.prevent="sendEquipamentDataPhotos"
      >
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-col-12">
            <FileUpload
              class="equipment-photos-parts"
              ref="label"
              mode="advanced"
              id="label"
              name="label[]"
              chooseLabel="Foto Etiqueta do Equipamento"
              accept="image/*"
              :fileLimit="1"
              :showUploadButton="false"
              :showCancelButton="false"
              :previewWidth="250"
            />
            <small class="p-error" role="alert" v-if="errorLabel">
              Foto Etiqueta do Equipamento é Obrigatória
            </small>
          </div>
          <div class="p-col-12 p-mt-3">
            <FileUpload
              class="equipment-photos-parts"
              ref="breakdown"
              mode="advanced"
              id="breakdown"
              name="breakdown[]"
              chooseLabel="Foto Avaria"
              accept="image/*"
              :fileLimit="1"
              :showUploadButton="false"
              :showCancelButton="false"
              :previewWidth="250"
            />
            <small class="p-error" role="alert" v-if="errorBreakdown">
              Foto da Avaria é obrigatória
            </small>
          </div>
          <div class="p-col-12 p-mt-3">
            <FileUpload
              class="equipment-photos-parts"
              ref="pop"
              mode="advanced"
              id="pop"
              name="pop[]"
              chooseLabel="Foto POP"
              accept="image/*"
              :fileLimit="1"
              :showUploadButton="false"
              :showCancelButton="false"
              :previewWidth="250"
            />
            <small class="p-error" role="alert" v-if="errorPop">
              Foto da Avaria é obrigatória
            </small>
          </div>
        </div>
      </form>
      <template #footer>
        <Button
          :label="'Guardar'"
          icon="pi pi-save"
          class="p-button-success"
          @click="sendEquipamentDataPhotos"
        />
        <Button
          label="Cancelar"
          icon="pi pi-times"
          class="p-button-danger"
          @click="close"
        />
      </template>
    </Dialog>
  </div>
</template>
<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import supportService from "../../services/support.service";
export default {
  name: "EquipamentPhotos",
  props: ["show", "service"],
  components: { Loading },
  watch: {
    async show() {
      if (this.show === true) {
        this.task_id = this.service.id;
      } else {
        this.reset();
      }
    },
  },
  data() {
    return {
      loading: false,
      task_id: null,
      errorLabel: false,
      errorBreakdown: false,
      errorPop: false,
    };
  },
  methods: {
    reset() {
      this.errorLabel = false;
      this.errorBreakdown = false;
      this.errorPop = false;
      this.task_id = null;
      return (this.loading = false);
    },
    close() {
      this.reset();
      return this.$emit("close");
    },
    sendEquipamentDataPhotos() {
      // this.errorLabel = this.$refs.label.files.length == 0 ? true : false;
      // this.errorBreakdown =
      //   this.$refs.breakdown.files.length == 0 ? true : false;
      // this.errorPop = this.$refs.pop.files.length == 0 ? true : false;
      // if (this.errorLabel || this.errorBreakdown || this.errorPop) {
      //   return;
      // }
      return this.savePhotos();
    },
    savePhotos() {
      this.loading = true;
      let formData = new FormData();
      if (this.$refs.label.files.length == 1) {
        formData.append("label", this.$refs.label.files[0]);
      }
      if (this.$refs.breakdown.files.length == 1) {
        formData.append("breakdown", this.$refs.breakdown.files[0]);
      }
      if (this.$refs.pop.files.length == 1) {
        formData.append("pop", this.$refs.pop.files[0]);
      }
      supportService
        .addInterventionPhotos(this.task_id, formData)
        .then((response) => {
          if (!response) {
            return this.$toast.add({
              severity: "error",
              summary: "Erro ao Gravar Ficheiros",
              detail: "Ocorreu um erro ao guardar os Ficheiros",
              life: 3000,
            });
          }
          this.loading = false;
          return this.$emit("sendedPhotos", response);
        });
    },
  },
};
</script>
<style>
.equipment-photos-parts .p-fileupload-row > :nth-child(2),
.equipment-photos-parts .p-fileupload-row > :nth-child(3) {
  display: none !important;
}
.p-fileupload {
  width: 100% !important;
}

.equipament-photos-main > img {
  width: 150px !important;
  height: auto !important;
}

.equipment-photos-parts .p-fileupload-row > :nth-child(1) {
  min-width: 90% !important;
  display: flex !important;
  justify-content: center !important;
}
</style>
